import { createFileRoute } from "@tanstack/react-router";
import { AccountDeletionPage } from "@/features/auth/components/AccountDeletionPage";

export const Route = createFileRoute("/_authenticated/account/deletion")({
  head: () => ({ meta: [{ title: "Account deletion · Pax.co" }] }),
  component: AccountDeletionPage,
});
